import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const nextfleeteldConfig: TSPConfig = {
  key: 'nextfleeteld',
  name: 'NextFleet ELD',
  imageName: 'NextFleetELD',
  category: TSPCategory.API_KEY,
  helpText:
    'Please request an API Key from NextFleet ELD support. Then input it here.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default nextfleeteldConfig;
